'use client';

import { useCallback } from 'react';

import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { useCommunityContext } from '../contexts/community/useCommunityContext';
import { toggleMemberBlock } from '../functions/members/toggleMemberBlock';

/**
 * Toggle a channel member's blocked flag (owner moderation). `creatorId` is the
 * STORE owner (the `stores/{creatorId}/...` root the member doc lives under)
 * from the community context — NOT the acting viewer; only the owner reaches
 * this action. Shared by the message kebab menu and the author user card so the
 * block wiring lives in one place.
 */
export function useToggleMemberBlock({
  channelId,
  memberId,
}: {
  channelId: string | null | undefined;
  memberId: string | null | undefined;
}) {
  const { creatorId } = useCommunityContext();
  const currentUserId = useCurrentUserId();
  return useCallback(async () => {
    if (!creatorId || !currentUserId || !channelId || !memberId) return;
    await toggleMemberBlock({
      creatorId,
      channelId,
      memberId,
    });
  }, [creatorId, currentUserId, channelId, memberId]);
}
